import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { showToast } from '../config/Alert';
import { Form, Button, InputGroup } from 'react-bootstrap';
import signup from "../assets/images/signup.webp";
import { signupApi } from '../services/AuthApi';
import Eye from "../assets/images/eye.png";
import EyeSlash from "../assets/images/eye-blind.png";

const Signup = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ name: "", email: "", mobile_number: "", password: "", confirmPassword: "" });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const toggleVisibility = () => setShowPassword(!showPassword);
    const toggleConfirmVisibility = () => setShowConfirmPassword(!showConfirmPassword);

    const validatePassword = (value) => {
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{8,14}$/;
        return regex.test(value);
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const validateForm = () => {
        let errors = {};
        if (!formData.name) errors.name = "Name is required";
        if (!formData.email) {
            errors.email = "Email is required";
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(formData.email)) {
                errors.email = "Invalid email format";
            }
        }
        if (!formData.mobile) {
            errors.mobile = "Mobile number is required";
        } else {
            const mobileRegex = /^[0-9]{10}$/;
            if (!mobileRegex.test(formData.mobile)) {
                errors.mobile = "Invalid mobile number format";
            }
        }
        if (!formData.password) errors.password = "Password is required";
        if (!formData.confirmPassword) errors.confirmPassword = "Confirm Password is required";
        if (formData.password !== formData.confirmPassword) errors.confirmPassword = "Passwords do not match";

        if (!validatePassword(formData.password)) {
            errors.password =
                'Password must be 8-14 characters and include uppercase, lowercase, number, and special character.'
        }
        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validateForm();
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length === 0) {
            setLoading(true);
            try {
                await signupApi({
                    name: formData.name,
                    email: formData.email,
                    mobile: formData.mobile,
                    password: formData.password
                });
                showToast("Signup successful! Please login.", 'success');
                navigate("/login");
            } catch (error) {
                showToast(error?.errors || "Signup failed. Please try again.", 'error');
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <div className='login-form bg_light_yellow p-3'>
            <div className='login_main_form bg-white rounded-4'>
                <div className='text-center'>
                    <h1 className='fw-bold text-danger fs-20'>Sign Up</h1>
                    <h6 className='text-muted fs-10'>To Join the Pied Piper Community</h6>
                </div>
                <Form className='mb-5 pt-3' onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="name">
                        <Form.Control
                            type="text"
                            size='lg'
                            className='border-2 border-secondary'
                            placeholder='Your Name'
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                        />
                        {errors.name && <small className="text-danger">{errors.name}</small>}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="email">
                        <Form.Control
                            type="email"
                            size='lg'
                            className='border-2 border-secondary'
                            placeholder='Email'
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                        />
                        {errors.email && <small className="text-danger">{errors.email}</small>}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="mobile">
                        <Form.Control
                            type="text"
                            size='lg'
                            className='border-2 border-secondary'
                            placeholder='Mobile Number'
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleChange}
                        />
                        {errors.mobile && <small className="text-danger">{errors.mobile}</small>}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="password">
                        <InputGroup>
                            <Form.Control
                                type={showPassword ? 'text' : 'password'}
                                size='lg'
                                className='border-2 border-secondary'
                                placeholder='Password'
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                            />
                            <InputGroup.Text onClick={toggleVisibility} style={{ cursor: 'pointer' }}>
                                <img src={showPassword ? Eye : EyeSlash} alt="toggle visibility" width={20} />
                            </InputGroup.Text>
                        </InputGroup>
                        {errors.password && <small className="text-danger">{errors.password}</small>}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="confirmPassword">
                        <InputGroup>
                            <Form.Control
                                type={showConfirmPassword ? 'text' : 'password'}
                                size='lg'
                                className='border-2 border-secondary'
                                placeholder='Confirm Password'
                                name="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                            />
                            <InputGroup.Text onClick={toggleConfirmVisibility} style={{ cursor: 'pointer' }}>
                                <img src={showConfirmPassword ? Eye : EyeSlash} alt="toggle visibility" width={20} />
                            </InputGroup.Text>
                        </InputGroup>
                        {errors.confirmPassword && <small className="text-danger">{errors.confirmPassword}</small>}
                    </Form.Group>
                    <Form.Group className='text-center'>
                        <Button variant="info" size='lg' type="submit" className='px-5 text-white border-2 border-secondary' disabled={loading}>
                            {loading ? 'Signing Up...' : 'Sign Up'}
                        </Button>
                    </Form.Group>
                    <p className='text-center mt-2'><Link to='/login' className='fw-bold text-decoration-none fs-12 text-danger'>Existing User? Login</Link></p>
                </Form>

                <img src={signup} alt="signup" className='img-fluid' />
            </div>
        </div>
    );
}

export default Signup;